<template>
  <GridPage
    title="Product Collections"
    subtitle=""
    viewset="/shop/admin/collections/"
    :actions="actions"
    :filters="filters"
    :fields="fields"
    :showAddButton="false"
    :refresh="refresh"
    @addButton="handleAddButton"
    @rowAction="handleRowAction"
  >
    <template v-slot:modals>
      <EditModal :editPK="editPK" @close="handleCloseEditModal" @dataUpdated="handleDataUpdated"/>
      <AddModal :show-modal="showAddModal" @close="handleCloseAddModal"  @dataUpdated="handleDataUpdated"/>
    </template>

    <template v-slot:filters>
      <DropDownCheckList
        :items="publishedFilterOptions"
        text="Published"
        icon="filter_list"
        v-model="publishedFilter"
        highlightClass="bg-light"
        radio
      />
    </template>
  </GridPage>
</template>

<script>
import GridPage from "@/components/layout/Page/GridPage.vue";
import DropDownCheckList from "@/components/DropDownChecklist.vue";
import formatters from "@/components/DataGrid/formatters"

import EditModal from "./EditModal";
import AddModal from "./AddModal";

export default {
  data() {
    return {
      showAddModal: false,
      editPK: null,
      publishedFilterOptions: [
            { name: "", title: "Show All" },
            { name: "1", title: "Published Only" },
            { name: "0", title: "Unpublished Only" },
      ],
      publishedFilter: "",
      refresh: 0,
      actions: [
        {
          name: "Edit",
          icon: "edit",
          event: "edit",
        },
      ],
      fields: [
        {
          name: "id",
          title: "id",
          sortField: "id",
          visible: false,
        },
        {
          name: "name",
          title: "Name",
          sortField: "name",
          visible: true,
          schema: {
            type: "input",
            inputType: "text",
            label: "Name",
            model: "name",
            placeholder: "Name",
            required: true,
          },
        },
        {
          name: "created_at",
          title: "Created",
          sortField: "created",
          formatter: formatters.datetime.withSubtext,
          visible: false,
        },
        {
          name: "updated_at",
          title: "Last Updated",
          sortField: "updated",
          formatter: formatters.datetime.withSubtext,
          visible: true,
        },
        {
          name: "status",
          title: "Status",
          sortField: "status",
          visible: true,
        },
      ],
    };
  },
  computed: {
    filters() {
      return {
        enabled: this.publishedFilter
      }
    }
  },
  methods: {
    handleRowAction(data) {
      if (data.action.event === 'edit') {
        this.editPK = data.props.rowData.id
      }
    },
    handleCloseEditModal(event) {
      this.editPK = null;
    },
    handleAddButton(event) {
      this.showAddModal = true;
    },
    handleCloseAddModal(event) {
      this.showAddModal = false;
    },
    handleDataUpdated(event) {
      this.refresh = this.refresh + 1;
    },
  },
  components: {
    GridPage,
    EditModal,
    AddModal,
    DropDownCheckList
  },
  beforeCreate() {
    // this.$store.dispatch("productCollections/init");
  },
};
</script>

<style></style>
